import * as React from 'react';
import { useSelector } from 'react-redux';
// import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  IProgressBarListProps,
  IProgressBarProps,
  ProgressBarItemStatus,
} from './ProgressBar.types';
import ProgressBarItem from './ProgressBarItem';
import {
  JssBarContainer,
  ProgressBarContainer,
  DesktopProgressBarContainer,
  ProgressBarPaper,
} from './ProgressBar.styles';
import CollapsibleProgressBar from './CollapsibleProgressBar/CollapsibleProgressBar';
import { JOURNEYS } from '../../../constants/index';
import { RootState } from '../../../store/store';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-nextjs/utils';
import { getCookie } from 'cookies-next';

const journeyProgresMap: Record<string, string> = {
  [JOURNEYS.JOURNEY_01]: 'progressBarItemsJ1',
  [JOURNEYS.JOURNEY_02]: 'progressBarItemsJ2',
  [JOURNEYS.JOURNEY_03]: 'progressBarItemsJ3',
};

// const fallbackFields: IProgressBarFields = {
//   progressBarItems: [
//     {
//       fields: {
//         name: { value: 'default' },
//         status: { value: ProgressBarItemStatus.disabled },
//       },
//     },
//   ],
// };
export const NormalProgressBar: React.FC<IProgressBarListProps> = (props) => {
  // let progressBarItems = fallbackFields.progressBarItems;
  let progressBarItems: any = [];
  if (Array.isArray(props.progressBarItems)) {
    progressBarItems = props.progressBarItems;
  }
  return (
    <JssBarContainer>
      {progressBarItems!.map((item: any, index: number) => (
        <ProgressBarItem
          index={index + 1}
          key={index}
          fields={item.fields}
          isRemoveBackground={props.isRemoveBackground}
        />
      ))}
    </JssBarContainer>
  );
};

const ProgressBar: React.FC<IProgressBarProps> = (props) => {
  const cdpData = useSelector((state: RootState) => state?.cdpData);
  let journeyType = getCookie('journeyType');
  if (!props?.fields) return <></>;

  // set fallback as initial data
  // let progressBarItems = fallbackFields.progressBarItems;
  let progressBarItems: any = [];

  //progress bar is dynamic in behavior depends on journeyType
  //but in exp editor we are setting in it to some default value
  if (isEditorActive()) {
    journeyType = JOURNEYS.JOURNEY_01;
  }
  if (journeyType && typeof journeyType === 'string') {
    const progressBarItemsPropertyName = journeyProgresMap[journeyType];
    if (progressBarItemsPropertyName) {
      const newProgressBarItems = props.fields?.[progressBarItemsPropertyName];
      if (Array.isArray(newProgressBarItems) && newProgressBarItems.length > 0) {
        progressBarItems = newProgressBarItems;
      }
    }
  }

  const isDnq = cdpData?.isDnq === true;
  if (journeyType === JOURNEYS.JOURNEY_02 && isDnq && Array.isArray(progressBarItems)) {
    const activeIndex = progressBarItems.findIndex(
      (item: any) => item?.fields?.status?.value === ProgressBarItemStatus.active
    );
    if (activeIndex !== -1) {
      progressBarItems = progressBarItems.slice(0, activeIndex + 1);
    }
  }

  let isCollapse = false; // Should ProgressBar Collapse on Mobile view
  if ((props as any)?.params?.isCollapse === '1') {
    isCollapse = true;
  }

  let isRemoveBackground = false; // Should ProgressBar Remove Background on Mobile view
  if ((props as any)?.params?.isRemoveBackground === '1') {
    isRemoveBackground = true;
  }

  return (
    <>
      <ProgressBarContainer>
        {isCollapse ? (
          <CollapsibleProgressBar
            progressBarItems={progressBarItems}
            isRemoveBackground={isRemoveBackground}
          />
        ) : (
          <ProgressBarPaper elevation={3}>
            <NormalProgressBar
              progressBarItems={progressBarItems}
              isRemoveBackground={isRemoveBackground}
            />
          </ProgressBarPaper>
        )}
      </ProgressBarContainer>
      <DesktopProgressBarContainer data-testid={'progressbartestid'}>
        {/* Tablet and Desktop */}
        <NormalProgressBar
          progressBarItems={progressBarItems}
          isRemoveBackground={isRemoveBackground}
        />
      </DesktopProgressBarContainer>
    </>
  );
};
export default ProgressBar;
